import { Keyword, ContainFlags } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
const { either } = Parser;
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/contain}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), either(Keyword.parse("none", "strict", "content"), ContainFlags.parse), (value) => value, { inherits: false });
//# sourceMappingURL=contain.js.map